module.exports = __webpack_public_path__ + "static/media/about.9eeee4a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/about.jpg
// module id = 122
// module chunks = 0